import { useQuery } from '@apollo/client';
import { useLogin } from '@bnnvara/accounts';
import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import get from 'lodash/get';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import ContentPageQuery from '../../pages/[brandSlug]/[slug]/ContentPage.gql';
import Header from './Header';

const StandalonePageHeader = ({ slug }) => {
  const { slug: brandSlug } = useBrand();
  const { isLoggedIn, login } = useLogin();
  const router = useRouter();

  // in the new architecture this query  is not needed and can be removed
  const { loading, data } = useQuery(ContentPageQuery, {
    variables: {
      brandSlug,
      slug,
    },
  });

  if (loading) {
    return null;
  }

  const page = get(data, 'brand.page', null);
  const imageUrl = get(page, 'headerImage.url', null);
  const callToAction = get(page, 'callToAction', null);
  const button = {
    text: callToAction ? callToAction.text : null,
    url: callToAction ? callToAction.url : null,
    onClick: callToAction ? track('header', 'click', 'cta') : null,
  };

  if (slug === 'wijzijnvoor-jijook') {
    button.text = isLoggedIn ? 'Naar mijn profiel' : 'Leuk, ik meld me aan';
    button.url = '/profiel';
    button.onClick = () => {
      track('header', 'click', 'cta');

      if (isLoggedIn) {
        router.push('/profiel');
      } else {
        login();
      }
    };
  }

  return (
    <Header
      backgroundImageUrl={imageUrl}
      title={page.title}
      subtitle={page.description}
      buttonText={button.text}
      buttonUrl={button.url}
      buttonOnClick={button.onClick}
    />
  );
};

StandalonePageHeader.propTypes = {
  slug: PropTypes.string.isRequired,
};

export default StandalonePageHeader;
